__turbopack_context__.v({
  "size-1": "Text-module-scss-module__NQ9Fnq__size-1",
  "size-10": "Text-module-scss-module__NQ9Fnq__size-10",
  "size-11": "Text-module-scss-module__NQ9Fnq__size-11",
  "size-2": "Text-module-scss-module__NQ9Fnq__size-2",
  "size-3": "Text-module-scss-module__NQ9Fnq__size-3",
  "size-4": "Text-module-scss-module__NQ9Fnq__size-4",
  "size-5": "Text-module-scss-module__NQ9Fnq__size-5",
  "size-6": "Text-module-scss-module__NQ9Fnq__size-6",
  "size-7": "Text-module-scss-module__NQ9Fnq__size-7",
  "size-8": "Text-module-scss-module__NQ9Fnq__size-8",
  "size-9": "Text-module-scss-module__NQ9Fnq__size-9",
  "weight-bold": "Text-module-scss-module__NQ9Fnq__weight-bold",
  "weight-medium": "Text-module-scss-module__NQ9Fnq__weight-medium",
  "weight-normal": "Text-module-scss-module__NQ9Fnq__weight-normal",
  "weight-semibold": "Text-module-scss-module__NQ9Fnq__weight-semibold",
});
